import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheckToSlot,
  faHouse,
  faBoxArchive,
  faFileInvoice,
  faBuilding,
  faBookmark,
  faPlaneUp,
  faHome,
  faCity,
  faEarthAsia,
  faGear,
  faChevronLeft,
  faBox,
  faRectangleList,
  faShuffle,
  faCreditCard,
  faTruck,
  faUsers,
  faHeadset,
  faBarsStaggered,
  faTruckArrowRight,
  faList,
  faClipboard,
  faFileInvoiceDollar,
  faChartSimple,
  faInfoCircle,
  faThumbtack,
  faThumbtackSlash,
  faBoxesPacking,
  faMoneyBills,
  faHandHoldingDollar,
  faSackDollar,
  faPlane,
  faChartPie,
  faChartBar,
  faChartLine,
  faRoute,
  faWeightScale,
  faFilter,
  faMoneyBillTrendUp,
  faClipboardList,
  faCheckCircle,
  faExclamationTriangle,
  faClock,
  faWallet,
  faPercentage,
  faMinusCircle,
  faFileContract,
  faLocationDot,
  faListCheck,
  faDollarSign,
  faTruckFast,
  faBoxesStacked,
  faFileShield,
  faFileSignature,
  faTags,
  faMoneyBillTransfer,
  faChartColumn,
  faCircleCheck,
  faCalendarDay,
  faScaleBalanced,
  faHourglassHalf,
  faArrowTrendUp,
  faPlaneCircleCheck,
  faBoxOpen,
  faMapLocationDot,
  faArrowsRotate,
  faAddressCard,
  faUserGroup,
  faUserShield,
  faMap,
  faSliders,
  faCoins,
  faHeartPulse
} from '@fortawesome/free-solid-svg-icons';
import { faBell } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(
  faCheckToSlot,
  faHouse,
  faBoxArchive,
  faFileInvoice,
  faBuilding,
  faBookmark,
  faBell,
  faPlaneUp,
  faHome,
  faCity,
  faEarthAsia,
  faGear,
  faChevronLeft,
  faBox,
  faRectangleList,
  faShuffle,
  faCreditCard,
  faTruck,
  faBarsStaggered,
  faTruckArrowRight,
  faList,
  faClipboard,
  faFileInvoiceDollar,
  faChartSimple,
  faUsers,
  faHeadset,
  faDollarSign,
  faInfoCircle,
  faThumbtack,
  faThumbtackSlash,
  faBoxesPacking,
  faPlane,
  faMoneyBills,
  faHandHoldingDollar,
  faSackDollar,
  faChartPie,
  faChartBar,
  faChartLine,
  faRoute,
  faWeightScale,
  faFilter,
  faMoneyBillTrendUp,
  faClipboardList,
  faCheckCircle,
  faExclamationTriangle,
  faClock,
  faWallet,
  faPercentage,
  faMinusCircle,
  faFileContract,
  faLocationDot,
  faListCheck,
  faTruckFast,
  faBoxesStacked,
  faFileShield,
  faFileSignature,
  faTags,
  faMoneyBillTransfer,
  faChartColumn,
  faCircleCheck,
  faCalendarDay,
  faScaleBalanced,
  faHourglassHalf,
  faArrowTrendUp,
  faPlaneCircleCheck,
  faBoxOpen,
  faMapLocationDot,
  faArrowsRotate,
  faAddressCard,
  faUserGroup,
  faUserShield,
  faMap,
  faSliders,
  faCoins,
  faHeartPulse
);

export const registerFontawesome = (app) => {
  app.component('FontAwesomeIcon', FontAwesomeIcon);
};
